import React from 'react';
import { FormattedMessage } from 'react-intl';
/**
 * CZNA-949 — "the author answered and no supervisor has written since", on a list row, so
 * the supervisor does not have to open each returned proposal to find out.
 */
var AuthorRepliedBadge = function () { return (React.createElement("span", { "data-testid": "author-replied-badge", style: {
        marginLeft: '0.5em',
        padding: '0 0.4em',
        borderRadius: '3px',
        fontSize: '0.85em',
        whiteSpace: 'nowrap',
        backgroundColor: '#e8f5e9',
        border: '1px solid #81c784',
        color: '#1b5e20',
    } },
    React.createElement(FormattedMessage, { id: "ui-czna-authorities.reviewThread.authorReplied" }))); };
export default AuthorRepliedBadge;
